module.exports = __webpack_public_path__ + "static/media/option-email.fa9060e0.png";